import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import PinForm from '../../../components/forms/PinForm';
import { usePinById, useUpdatePin } from '../../../hooks/usePinApi';
import { useNavigate, useParams } from 'react-router-dom';

const PinEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = usePinById(id!);
  const updatePin = useUpdatePin();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Pins', href: '/admin/pins' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updatePin.mutateAsync({ id: id!, data });
      navigate('/admin/pins');
    } catch (error) {
      console.error('Error updating Pin:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/pins"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Pin.Edit'
    >
      {entityData ? (
        <PinForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/pins')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default PinEdit;
